<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">{{ title }}</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      <div class="advanced-dialog-content">
        @if (account?.accountId) {
          <mat-form-field class="flex-half">
            <mat-label>Log Level</mat-label>
            <input
              [lcsSingleSelect]="logLevelSelect"
              ndtLogLevelSelect
              autocomplete="off"
              type="text"
              formControlName="logLevelId"
              id="logLevelId"
              required
              />
              <ndt-log-level-select #logLevelSelect></ndt-log-level-select>
              @if (form.get('logLevelId')?.hasError('required')) {
                <mat-error> Log Level is Required. </mat-error>
              }
            </mat-form-field>
          }
          @if (account?.accountId) {
            <mat-form-field class="flex-half">
              <mat-label>Log Level Reason</mat-label>
              <input
                matInput
                autocomplete="off"
                type="text"
                [value]="account?.reasonLogLevelChanged"
                formControlName="reasonLogLevelChanged"
                />
                @if (
                  form.get('reasonLogLevelChanged')?.hasError('pattern') ||
                  form.get('reasonLogLevelChanged')?.hasError('whitespace')
                  ) {
                  <mat-error
                    >
                    Log Level Reason cannot contain leading spaces.
                  </mat-error>
                }
                @if (form.get('reasonLogLevelChanged')?.hasError('required')) {
                  <mat-error>
                    Log Level Reason required
                  </mat-error>
                }
              </mat-form-field>
            }
          </div>
        </mat-dialog-content>
        <mat-dialog-actions>
          <button type="submit" title="Confirm" mat-raised-button>OK</button>
          <button type="button" title="Cancel" mat-stroked-button (click)="onCloseClick()">Cancel</button>
        </mat-dialog-actions>
      </form>
    </lcs-loading-overlay>
